import React from 'react'
import Spinner from 'spinner'

/**
 * Chose a plan step of sign-up.
 * This is actually exists over on the /pricing page so the user will be navigated there
 */
const ChooseAPlan = () : JSX.Element => {
    window.location.href = process.env.REACT_APP_PRICING_PAGE_URL

    return (
        <Spinner />
    )
}

export default ChooseAPlan
